import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js/pure";
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import { Elements, } from "@stripe/react-stripe-js";
import StripeService from "../services/stripe.service";
import { increaseQuantity, lowerQuantity, removeFromCart } from "actions/cart";
import Spinner from 'react-bootstrap/Spinner';
import { FaPlus, FaMinus } from 'react-icons/fa';
import Analytics from "analytics";
import ErrorModal from '../components/Utlility/ErrorModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import DotLoader from 'components/Utlility/DotLoader';
import { getCookie } from 'helpers/cookies';

import Reviews from "constants/reviews";

// Slick Carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./carouselStyles.css";
import Slider from "react-slick";
import StarFull from "images/template/full-star.png";
import StarEmpty from "images/template/empty-star.png";

import CheckoutForm from "./Forms/CheckoutForm";
import FormPage from "./Forms/FormPage";
import { Container, Row, Form, Alert } from "react-bootstrap";
import styles from "./CheckoutStyles.module.scss";
// import styles from "./Forms/FormStyles.module.scss";
import bin from "images/icons/bin.png"
import Game from "./Games/Game";
import GameList from "../constants/GameList";
import GamePackList from "../constants/GamePackList";
import GameAddonList from "../constants/GameAddonList";
import pricing from "../reducers/pricing";
import PricingFunctions from "../common/PricingFunctions";

import UpsellModal from "components/Modals/UpsellModal/UpsellModal";

export default function Checkout() {
    const [clientSecret, setClientSecret] = useState("");
    const [checkoutStep, setCheckoutStep] = useState(false);
    const [checkoutItems, setCheckoutItems] = useState([]);
    const [currency, setCurrency] = useState("");
    const [loadingCheckout, setLoadingCheckout] = useState(false);
    const [cartTotal, setCartTotal] = useState(0);
    const [rewardsCouponId, setRewardsCouponId] = useState(null);
    const [checkoutTotal, setCheckoutTotal] = useState(0);
    const [checkoutSavingsTotal, setCheckoutSavingsTotal] = useState(0);
    const [rewardDiscountInitilised, setRewardDiscountInitilised] = useState(false);
    const [rewardsDiscount, setRewardsDiscount] = useState(0);
    const [requiredToSave, setRequiredToSave] = useState(0);
    const [stripePromise, setStripePromise] = useState(null);

    const [promoCode, setPromoCode] = useState("");
    const [promoBoxOpen, setPromoBoxOpen] = useState(true);
    const [checkingPromoCode, setCheckingPromoCode] = useState(false);
    const [promoCodeApplied, setPromoCodeApplied] = useState(false);
    const [promoCodeMessageFromStripe, setPromoCodeMessageFromStripe] = useState("");
    const [promoCodeMessage, setPromoCodeMessage] = useState("");
    const [promoCodePercentage, setPromoCodePercentage] = useState("");
    const [discount, setDiscount] = useState("");
    const [discountProducts, setDiscountProducts] = useState(null);
    const [email, setEmail] = useState("");
    const [showAgeWarning, setShowAgeWarning] = useState(false);
    const [firstName, setFirstName] = useState("");

    const [showUpsell, setShowUpsell] = useState(false);
    const [upsellItem, setUpsellItem] = useState(null);

    const { items, } = useSelector(state => state.cart);
    const { isLoggedIn, user } = useSelector(state => state.auth);
    const { countryCode, } = useSelector(state => state.pricing);
    const { discountCode, } = useSelector(state => state.discount);
    const dispatch = useDispatch();

    const carouselSettings = {
        dots: true,
        dotsClass: "slick-dots slick-thumb",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        // nextArrow: <SampleNextArrow />,
        // prevArrow: <SamplePrevArrow />,
        customPaging: function (i) {
            return (
                <div className="carousel-dot">

                </div>
            );
        },
    };

    useEffect(() => {
        let amount = 0;
        let required = 0;
        let savings = 0;
        let rewardsDiscount = 0;

        const localeLower = PricingFunctions.getRewardsLower(countryCode);
        const localeMid = PricingFunctions.getRewardsMid(countryCode);

        items.forEach((item) => {
            console.log(item);
            amount += Number(getNumericPrice(item));
        });

        if (amount < localeLower.amount) {
            setRewardsCouponId(null);
            required = (localeLower.amount - amount).toFixed(2);
        }
        else if (amount < localeMid.amount) {
            rewardsDiscount = localeLower.discount;
            setRewardsCouponId(localeLower.couponId);
            required = (localeMid.amount - amount).toFixed(2);
            savings = Number((amount / 100) * localeLower.discount).toFixed(2);
            
        } else {
            setRewardsCouponId(localeMid.couponId);
            rewardsDiscount = localeMid.discount;
            savings = Number((amount / 100) * localeMid.discount).toFixed(2);
            
        }
        if (promoCodeApplied) {
            if (promoCodePercentage < rewardsDiscount) {
                setPromoCodeMessage("Promo code not applied. You're already saving more with Game City Rewards!");
            } else {
                setRewardsCouponId(null);
                savings = Number((amount / 100) * promoCodePercentage).toFixed(2);

                if (promoCodeMessageFromStripe !== "" && promoCodeMessageFromStripe !== null) {
                    setPromoCodeMessage(promoCodeMessageFromStripe);
                } else {
                    setPromoCodeMessage("Promo code will be applied at checkout.");
                }
            }
        }

        setRewardsDiscount(rewardsDiscount);
        setRewardDiscountInitilised(true);
        setRequiredToSave(required);
        setCheckoutSavingsTotal(savings);
        setCheckoutTotal(amount);

    }, [discountCode, promoCodeApplied, promoCodePercentage, JSON.stringify(items.map(i => i.quantity))]);


    useEffect(() => {
        if (!rewardDiscountInitilised) return;
        setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_KEY));
        console.log("Looking for discount in redux");
        console.log("Items : ", items);
        if (isLoggedIn) {
            setEmail(user.email);
        }

        if (discountCode != null) {
            console.log("Found it : ", discountCode);
            setPromoCode(discountCode);
            setPromoBoxOpen(true);
            //setPromoCodeMessage(`The code ${discountCode} has been applied to your cart!`);
            //setPromoCodeApplied(true);
            
            checkPromotionCode(null, discountCode);
        }
    }, [discountCode, rewardDiscountInitilised]);

    const appearance = {
        theme: 'flat',
        variables: {

        }
    };
    const options = {
        clientSecret,
        appearance,
        loader: "auto"
    };

    const addQuantity = (item) => {
        if (!loadingCheckout) dispatch(increaseQuantity(item));
    }
    const minusQuantity = (item) => {
        if (!loadingCheckout) dispatch(lowerQuantity(item));
    }
    const removeItem = (item) => {
        if (!loadingCheckout) dispatch(removeFromCart(item));
    }

    const checkAgeRestriction = (e) => {
        e.preventDefault();
        if (items.find(i => i.minAge >= 17)) {
            setShowAgeWarning(true);
        }
        else continueToCheckout();
    }

    const cancelAgeWarning = () => {
        setShowAgeWarning(false);
    }

    const acceptAgeWarning = () => {
        setShowAgeWarning(false);
        continueToCheckout();
    }

   const getUpsellItem = () => {
        // Collect all item IDs we already have
        const existingIds = new Set(items.map(item => item.id));
        console.log("Existing Ids : ", existingIds);
        // Collect all upsell IDs from items
        let possibleIds = [];
        for (let item of items) {
            if (item.upsellIds != null) possibleIds.push(...item.upsellIds);
        }
        console.log("Possible Ids : ", possibleIds);

        // Filter out ones already in items
        possibleIds = possibleIds.filter(id => !existingIds.has(id));
        console.log("Possible Ids 2: ", possibleIds);

        if (possibleIds.length === 0) return null;


        // If logged in, filter out games already owned by user
        if (isLoggedIn && user?.games) {
        console.log("Is logged in");
        console.log("user games: ", user.games);
            const ownedCodes = new Set(user.games.map(g => g.code));
        console.log("owned codes: ", ownedCodes);
            possibleIds = possibleIds.filter(id => !ownedCodes.has(id));
        }
        
        console.log("Possible Ids 3: ", possibleIds);
        if (possibleIds.length === 0) return null;
        
        // Convert to actual game objects
        let possibleGames = GameList.filter(game => possibleIds.includes(game.gameId));
        console.log("Possible games: ", possibleGames);


        if (possibleGames.length === 0) return null;

        // Pick a random game
        return possibleGames[Math.floor(Math.random() * possibleGames.length)];
    }


    const continueToCheckout = (skipUpsell = true) => {
        setLoadingCheckout(true);
        
        if (!skipUpsell) {
            const upsellItem = getUpsellItem();
            if (upsellItem) {
                setUpsellItem(upsellItem);
                setShowUpsell(true)
;                return;
            }
        }

        console.log("Upsell Item : ", upsellItem);
        console.log(items)

        const rewardsAreBetter = rewardsDiscount > promoCodePercentage;
        var coupon = (promoCodeApplied && !rewardsAreBetter) ? promoCode : null;
        console.log(promoCodeApplied, promoCode,  coupon)
        const currency = PricingFunctions.getCurrency(countryCode);
        const source = getCookie("purchase_src");
        StripeService.createPaymentIntent(items, coupon, email, firstName, currency, countryCode, source, coupon ? null : rewardsCouponId)
            .then((res) => {
                setLoadingCheckout(false);
                setCheckoutStep(true);
                console.log("res data ", res.data);
                setCartTotal(res.data.cartTotal);
                setClientSecret(res.data.clientSecret)
                setCheckoutItems(res.data.checkoutItems);
                setCurrency(res.data.currency);
                if (res.data.discountPercentage) {
                    setDiscount(`-${res.data.discountPercentage}%`);
                    setDiscountProducts(res.data.applicableProducts);
                }
                Analytics.beginCheckout(items, currency, res.data.cartTotalRaw, coupon);
            }).catch((err) => {
                console.log("Error : ", err);
                setLoadingCheckout(false);
            });
    }

    const onChangeCode = (e) => {
        if (!checkingPromoCode && !promoCodeApplied) {
            const code = e.target.value.toUpperCase(); 
            setPromoCode(code);
        }
    };

    const onChangeEmail = (e) => {
        const email = e.target.value;

        setEmail(email);
    };

    const onChangeFirstName = (e) => {
        const firstName = e.target.value;
        localStorage.setItem("FirstName", firstName);
        setFirstName(firstName);
    }

    const checkPromotionCode = (e, force = null) => {
        if (e) e.preventDefault();
        let promoCodeToCheck = force || promoCode;
        console.log("promo code : ", promoCodeToCheck);
        console.log("promo code length : ", promoCodeToCheck.length)
        console.log("checking promo code : ", checkingPromoCode);
        if (promoCodeToCheck.length > 0 && !checkingPromoCode) {
            setCheckingPromoCode(true);
            setPromoCodeMessage("");
            const productIds = items.map((x) => x.productId);
            console.log("*** Checking Promo Code ***");
            StripeService.checkPromotionCode(promoCodeToCheck, productIds)
                .then((res) => {
                    console.log("Check promo code res: ", res);
                    if (res.data.valid === true) {

                        if (res.data.percentOff < rewardsDiscount) {
                            setPromoCodeApplied(true);
                            setPromoCodePercentage(res.data.percentOff);
                            setPromoCodeMessage("Promo code not applied. You're already saving more with Game City Rewards!");
                            setPromoCodeMessageFromStripe(res.data.message);
                        } else {
                            setPromoCodeApplied(true);
                            setPromoCodePercentage(res.data.percentOff);
                            setPromoCodeMessage(res.data.message);
                            setPromoCodeMessageFromStripe(res.data.message);
                        }
                    } else {
                        if (res.data.applicableProductIds && res.data.applicableProductIds.length > 0) {
                            const applicableProducts = [...GamePackList, ...GameList, ...GameAddonList].filter((x) => res.data.applicableProductIds.includes(x.productId));
                            const applicableProductNames = applicableProducts.map((x) => x.name);

                            setPromoCodeMessage(res.data.message + applicableProductNames.join(", ") + ".");
                            setPromoCodeMessageFromStripe(res.data.message + applicableProductNames.join(", ") + ".");
                        } else {
                            setPromoCodeMessage(res.data.message);
                            setPromoCodeMessageFromStripe(res.data.message);
                        }
                    }
                    setCheckingPromoCode(false);
                }).catch((err) => {
                    console.log("Check promo code err: ", err);
                    setPromoCodeApplied(false);
                    setCheckingPromoCode(false);
                    setPromoCodeMessage(err.message);
                    setPromoCodeMessageFromStripe(err.message);
                });
        }
    }

    const getPrice = (item) => {
        if (checkoutStep) {
            let checkoutItem = checkoutItems.find(x => x.productId === item.productId);
            let actualAmount = checkoutItem.total - checkoutItem.discountAmount;
            return `${PricingFunctions.getCurrencySymbol(countryCode)}${(actualAmount / 100).toFixed(2) }`;
        } else {
            let game = [...GameList, ...GamePackList, ...GameAddonList].find((x) => x.productId === item.productId);
            let pricing = PricingFunctions.getGamePricing(countryCode, game);
            let rawPrice = pricing.raw;
            return `${PricingFunctions.getCurrencySymbol(countryCode)}${(rawPrice * item.quantity).toFixed(2)}`;
        }
    }

    const getNumericPrice = (item) => {
        if (checkoutStep) {
            let checkoutItem = checkoutItems.find(x => x.productId === item.productId);
            let actualAmount = checkoutItem.total - checkoutItem.discountAmount;
            return (actualAmount / 100).toFixed(2);
        } else {
            let game = [...GameList, ...GamePackList, ...GameAddonList].find((x) => x.productId === item.productId);
            let pricing = PricingFunctions.getGamePricing(countryCode, game);
            let rawPrice = pricing.raw;
            return (rawPrice * item.quantity).toFixed(2);
        }
    }

    const getStrikePrice = (item) => {
        let checkoutItem = checkoutItems.find(x => x.productId === item.productId);
        if (checkoutItem.discountAmount) {
            let actualAmount = checkoutItem.total
            return `${PricingFunctions.getCurrencySymbol(countryCode)}${(actualAmount / 100).toFixed(2)}`;
        } else {
            return null;
        }
    }

    const upsellModalCallback = () => {
        setShowUpsell(false);
        continueToCheckout(true);
    }

    const isDev = () => { return !process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT === 'development' }

    const getTotalSavings = () => {
        let amount = 0;
        checkoutItems.forEach((item) => {
            if (item.discountAmount) {
                amount += item.discountAmount;
            }
        });
        console.log(`total savings : ${amount}`)
        if (amount === 0) return null;
        else return `${PricingFunctions.getCurrencySymbol(countryCode)}${(amount / 100).toFixed(2)}`;
    }

    const togglePromoBoxOpen = (value) => {
        if (!checkingPromoCode) {
            setPromoBoxOpen(value);
        }
    }

    const renderItemList = (list, title) => {
        return <table className={styles.checkoutTable}>
            <tr>
                <th>{title}</th>
                <th>Quantity</th>
                <th>Price</th>
                {
                    (!checkoutStep || getTotalSavings() != null) &&
                    <th></th>
                }
            </tr>
            {
                list.map(item => {
                    return renderItemRow(item);
                })
            }
            {!checkoutStep && 
            <tr className={styles.total}>
                <td className={styles.buffer}></td>
                <td className={styles.title}>Total</td>
                {checkoutSavingsTotal > 0 &&
                    <td style={{ textDecoration: "line-through", color: "darkgray" }}>{PricingFunctions.getCurrencySymbol(countryCode)}{(checkoutTotal).toFixed(2)}</td>
                }
                {checkoutSavingsTotal <= 0 &&
                    <td>{PricingFunctions.getCurrencySymbol(countryCode)}{(checkoutTotal).toFixed(2)}</td>
                }
            </tr>
            }
            {!checkoutStep && checkoutSavingsTotal > 0 &&
                <tr className={styles.total}>
                    <td className={styles.buffer}></td>
                    <td className={styles.title}>YOUR PRICE!</td>
                    <td>{PricingFunctions.getCurrencySymbol(countryCode)}{(checkoutTotal - checkoutSavingsTotal).toFixed(2)}</td>
                </tr>
            }

        </table>
    }

    const renderRewardsBox = () => {

        if (checkoutStep)
            return;

        let amount = checkoutTotal;
        let required = requiredToSave;
        let savings = checkoutSavingsTotal;

        const localeLower = PricingFunctions.getRewardsLower(countryCode);
        const localeMid = PricingFunctions.getRewardsMid(countryCode);

        // Check if promo code is better than rewards
        const promoIsBetter = promoCodeApplied && promoCodePercentage > localeMid.amount;

        // Check for Black Friday promo code (only if it's better than rewards)
        if (promoIsBetter && promoCode === "FRIDAY50") {
            return <div className={`${styles.rewardsBox} ${styles.blackFriday}`} >
                <h2>BLACK FRIDAY DEAL!</h2>
                <h2>YOU'RE SAVING {PricingFunctions.getCurrencySymbol(countryCode)}{savings}</h2>
                {/*<p>50% Off Black Friday Discount Applied!</p>*/}
                <Link to="/shop" className={styles.shopLink}>Continue Shopping</Link>
            </div>
        }

        if (promoIsBetter) {
            // Show promo code messaging instead of rewards
            return <div className={styles.rewardsBox}>
                <h2>Wahoo... YOU'RE SAVING {PricingFunctions.getCurrencySymbol(countryCode)}{savings}</h2>
                <p>Promo Code Applied - {promoCodePercentage}% Discount!</p>
                <Link to="/shop" className={styles.shopLink}>Continue Shopping</Link>
            </div>
        }

        if (amount < localeLower.amount) {
            return <div className={styles.rewardsBox}>
                <h2>Game.City Rewards</h2>
                <p>Just spend another <b>{PricingFunctions.getCurrencySymbol(countryCode)}{required}</b> to get <b>{localeLower.discount}% discount</b></p>
                <Link to="/shop" className={styles.shopLink}>Continue Shopping</Link>
            </div>
        }
        else if (amount < localeMid.amount) {
            return <div className={styles.rewardsBox}>
                <h2>You're saving {PricingFunctions.getCurrencySymbol(countryCode)}{savings}</h2>
                <p>Just spend another <b>{PricingFunctions.getCurrencySymbol(countryCode)}{required}</b> to get <b>{localeMid.discount}% off!</b></p>
                <Link to="/shop" className={styles.shopLink}>Continue Shopping</Link>
            </div>
        } else {
            return <div className={styles.rewardsBox}>
                <h2>Wahoo... YOU'RE SAVING {PricingFunctions.getCurrencySymbol(countryCode)}{savings}</h2>
                <p>Game City Rewards 30% Discount!</p>
                <Link to="/shop" className={styles.shopLink}>Continue Shopping</Link>
            </div>
        }

    }

    const renderItemRow = (item) => {
        return <tr>
            <td className={styles.itemName} >{item.name}</td>
            {
                checkoutStep ?
                    <>
                        <td>
                            <div className={styles.amountPicker}>
                                <div className={`${styles.quantity} ${checkoutStep && styles.checkoutStep}`}>{item.quantity}</div>
                            </div>
                        </td>
                        {/*<td><span style={{textDecoration: "line-through", color: "darkgray"}}>{getStrikePrice(item)}</span>{`${getPrice(item)} ${discountProducts != null && (discountProducts.includes(item.productId) || discountProducts.length == 0) ? discount : ""}` || <Spinner animation="border" size="sm" />}</td>*/}


                        <td>
                            {`${getPrice(item)}` || <DotLoader size="small" variant="dark" />}{` `}
                        </td>
                        {
                            getStrikePrice(item) &&
                            <td>
                                <span style={{ textDecoration: "line-through", color: "darkgray" }}>{checkoutItems.find((x) => x.productId === item.productId).discountAmount && getStrikePrice(item)}</span>
                            </td>
                        }
                    </>
                    :
                    <>
                        <td>
                            <div className={styles.amountPicker}>
                                <div className={styles.quantity}>{item.quantity}
                                    <button className={styles.minus} onClick={() => minusQuantity(item)}>
                                        {'<'}
                                    </button>
                                    <button className={styles.add} onClick={() => addQuantity(item)}>
                                        {'>'}
                                    </button>
                                </div>
                            </div>
                        </td>
                        <td>{`${getPrice(item)}` || <DotLoader size="small" variant="dark" />}</td>
                    </>
            }
        </tr>
    }

    return (
        <React.Fragment>
            {showUpsell && 1 == 2 && <UpsellModal upsellItem={upsellItem} callback={upsellModalCallback}></UpsellModal>}
            <FormPage is="checkout">
                <Container>
                    <Row>
                        {
                            items.length === 0 ?
                                <React.Fragment>
                                    <div className={styles.checkoutForm}>
                                        <h2 className={styles.formTitle}>Your Cart Is Empty...</h2>
                                        <Link to='/shop' className={styles.button}>Go To Shop</Link>
                                    </div>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <div className={`${styles.checkoutForm}`}>
                                        {checkoutStep ?
                                            <h2 className={styles.formTitle}>Checkout</h2>
                                            :
                                            <h2 className={styles.formTitle}>Your Cart</h2>
                                        }
                                        {!checkoutStep &&
                                            <p><b>Games can be automatically added to your account<br />Or...you can choose to grab a digital voucher as a gift.</b></p>
                                        }
                                        {renderRewardsBox()}                                        
                                        {
                                            promoCodeApplied && promoCodeMessage.length > 0 && discountCode != null &&
                                            <Alert variant={promoCodeApplied ? "success" : "danger"}>
                                                {promoCodeMessage}
                                            </Alert>
                                        }
                                        {renderItemList(items, "PRODUCT")}
                                        {
                                            checkoutStep &&
                                            <table className={styles.checkoutTable}>
                                                <tr className={styles.total}>
                                                    <td className={styles.buffer}></td>
                                                    <td className={styles.title}>Total</td>
                                                    <td>{cartTotal} {/*{discountProducts == null || discountProducts.length == 0 && discount}*/}</td>
                                                </tr>
                                                {
                                                    getTotalSavings() != null &&
                                                    <tr className={styles.totalSavings}>
                                                        <td></td>
                                                        <td>Total Savings</td>
                                                        <td>{getTotalSavings()}</td>
                                                        <td className={styles.bufferSmall}></td>
                                                    </tr>
                                                }
                                            </table>
                                        }
                                        {
                                            !loadingCheckout && !checkoutStep && <div className={styles.couponSection}>
                                                {
                                                    !promoCodeApplied && <Form.Label className={styles.title}><br/>Got a promo code?</Form.Label>
                                                }
                                                {
                                                    promoCodeApplied ?
                                                        <React.Fragment>
                                                            {/*<div>{promoCode}</div>*/}
                                                            {
                                                                promoCodeMessage.length > 0 && discountCode == null &&
                                                                <Alert variant={promoCodeApplied ? "success" : "danger"}>
                                                                    {promoCodeMessage}
                                                                </Alert>
                                                            }
                                                        </React.Fragment>
                                                        :
                                                        promoBoxOpen &&
                                                        <React.Fragment>
                                                                <Form.Control
                                                                    className={styles.inp}
                                                                    type="text"
                                                                    autoComplete="off"
                                                                    placeholder="Enter Promotion Code..."
                                                                    required
                                                                    onChange={onChangeCode}
                                                                    value={promoCode} // <-- Bind value from state
                                                                />
                                                            {
                                                                promoCodeMessage.length > 0 &&
                                                                <Alert variant={promoCodeApplied ? "success" : "danger"}>
                                                                    {promoCodeMessage}
                                                                </Alert>
                                                            }
                                                                <button onClick={checkPromotionCode} className={`${styles.button} ${styles.alternate} ${styles.small}`} style={{ marginBottom: "10px", marginTop: "10px" }}>{checkingPromoCode ? <DotLoader size="medium" variant="light" /> : 'Get Discount'}</button>

                                                        </React.Fragment>
                                                }

                                            </div>
                                        }
                                        {
                                            !checkoutStep &&
                                            <>
                                                <Form onSubmit={checkAgeRestriction}>
                                                    <FloatingLabel className="mb-3" controlId="formBasicFirstName" label="First Name">
                                                        <Form.Control
                                                            disabled={loadingCheckout}
                                                            type="text"
                                                            placeholder="First Name"
                                                            onChange={onChangeFirstName}
                                                            value={firstName}
                                                            autoComplete="given-name"
                                                            aria-label="First Name">
                                                        </Form.Control>
                                                    </FloatingLabel>
                                                    <FloatingLabel className="mb-3" controlId="formBasicEmail" label="Email*">
                                                        <Form.Control
                                                            disabled={loadingCheckout}
                                                            type="email"
                                                            placeholder="Email*"
                                                            required
                                                            onChange={onChangeEmail}
                                                            value={email}
                                                            autoComplete="email"
                                                            aria-label="Email">
                                                        </Form.Control>
                                                    </FloatingLabel>
                                                    <button className={`${styles.button} ${styles.wide}`} type="submit" id="submit" disabled={loadingCheckout}>{loadingCheckout ? <DotLoader size="medium" variant="light" /> : 'Checkout'}</button>
                                                </Form>
                                            </>
                                        }
                                    </div>
                                </React.Fragment>
                        }
                    </Row>
                    {
                        checkoutStep &&
                        <Row xs={12}>
                            {clientSecret ?
                                <Elements options={options} stripe={stripePromise}>
                                    <CheckoutForm email={email} />
                                </Elements>
                                :
                                <div className={`${styles.spinner}`} id="spinner"></div>
                            }
                        </Row>
                    }

                </Container>
            </FormPage>
            {
                !checkoutStep &&
                <section className={`${styles.band} ${styles.sm}`} style={{ backgroundColor: "#210f37" }}>
                    <Container>

                        <div className='row text-center justify-content-center'>
                            <h2 className='text-uppercase'>{items.length === 0 ? "Add Some Games" : "More Games You'll Love!"}</h2>
                                {GameList.filter(g => g.enabled || isDev()).map(g => <div className='col-md-6 col-lg-4 text-center'><Game showAddToCart={true} game={g} key={g.gameId} /></div>)}

                            {/* {GameList.filter(g => {g.gameId !== this.props.game.gameId }).map(g => <div className='col-md-6 col-lg-3 text-center'><Game game={g} key={g.gameId} /></div> )} */}

                            {/* {console.log(GameList.filter(g => {g.gameId !== this.props.game.gameId }))} */}
                        </div>
                    </Container>
                </section>
            }
            <section className={`${styles.reviewsSection} ${styles.band} ${styles.large}`}>
                <Slider className={styles.carousel} {...carouselSettings}>
                    {
                        Reviews.map((review) => {
                            return <div className={`${styles.reviewWidth} container p-0`}>
                                <div className={`${styles.reviewCard} card text-center mx-3 border-0 p-3`}>
                                    <h5 className={`${styles.reviewTitle} card-title`}>{review.name}</h5>
                                    <div className="row d-flex w-50 m-auto">
                                        {Array.from(Array(5), (e, i) => {
                                            return <div className="col p-1">
                                                <img className="img-fluid m-auto" style={{}} src={i <= review.stars - 1 ? StarFull : StarEmpty} />
                                            </div>
                                        })}
                                    </div>
                                    <div className={`${styles.reviewBody} card-body`}>
                                        <p className={`${styles.reviewText} card-text`}>{review.description}</p>
                                    </div>
                                </div>
                            </div>
                        })
                    }
                </Slider>
            </section>
            {showAgeWarning && <ErrorModal
                title={"Age Restriction Warning"}
                styles={`${styles.screenModel} d-flex`}
                message={"One or more items in your cart are rated for adults and are unsuitable for children, please confirm you are 17+ years old?"}
                callback={cancelAgeWarning}
                callbackText={"Cancel"}
                callback2={acceptAgeWarning}
                callbackText2={"Confirm"}
            />}

        </React.Fragment>
    );
}